<sbw-vehicles-details-row *ngFor="let row of inputDetailsRows; index as i"
    [model]="row"
    [mode]="mode"
    [index]="i"
    [selectedVehicleControl]="selectedVehicleControl"
    [selectedTrailerControl]="selectedTrailerControl"
    (created)="rowCreated($event)"
    (destroyed)="rowDestroyed($event)"></sbw-vehicles-details-row>

